import React from 'react';
import styled from 'styled-components';
import { get } from 'lodash';
import {
  attachLocale,
  getSigninUrlWithOrigin,
  resolveLanguageSwitchUrl,
} from '../../../../lib/utils';
import {
  DATA_TRACK_TYPE_INTERNAL,
  LANGUAGE_SWITCH,
  SIGN_IN_BUTTON,
} from '../../../../lib/constants';
import { getGlobalNavigationAnalytics } from './globalNavigationAnalytics';

const styles = {
  ACTIVE_LINK: 'active',
};

const buttonClass = (style) => {
  return get(styles, [style], '');
};

const GlobalNavLi = styled.li`
  display: flex;
  flex-direction: row; 
  &.active {
    background-color: ${p => p.theme.c.bg.primary};
  }
`;

const NavSlotAnchor = styled.a`
  color: ${p => p.theme.c.text.interactive};
  display: flex;
  text-decoration: none;
  padding: 3px;
  align-items: center;
  box-sizing: border-box;
  margin: 8px 11px;
  :hover {
    cursor: pointer;
    color: ${(p) => p.theme.c.text['interactive-hover']};
    text-decoration: underline;
  }
  &.active {
    color: ${(p) => p.theme.c.text.primary};
  }
`;

const globalNavigationSlot = ({
  text,
  analyticsSlug,
  url,
  openInNewTab,
  locale,
  navSlotPurpose,
  currentPath = '',
  localeUrls,
  subCategoryLocaleSlugMap,
  buttonStyle,
  leftSlot,
}) => {
  let localeToUse = url;
  if (url && url.length && url[0] === '/') {
    localeToUse = url.slice(1); // remove the first '/' if exist
  }

  let urlToUse;

  switch (navSlotPurpose) {
    case LANGUAGE_SWITCH: {
      urlToUse = resolveLanguageSwitchUrl({
        currentPath,
        targetLocale: localeToUse,
        localeUrls,
        subCategoryLocaleSlugMap,
      });
      break;
    }
    case SIGN_IN_BUTTON: {
      urlToUse = getSigninUrlWithOrigin({
        currentPath,
        signInUrl: attachLocale(url, locale),
      });
      break;
    }
    default: {
      urlToUse = attachLocale(url, locale);
    }
  }

  const track = getGlobalNavigationAnalytics({
    analyticsSlug,
    url: urlToUse,
  });

  return (
    <GlobalNavLi className={buttonClass(buttonStyle)}>
      <NavSlotAnchor
        id={track.dataTrackingId}
        data-track-id={track.dataTrackingId}
        data-track-click={track.dataTrack}
        data-track-type={DATA_TRACK_TYPE_INTERNAL}
        href={track.url}
        target={openInNewTab ? '_blank' : '_self'}
        className={buttonClass(buttonStyle)}
        leftSlot={leftSlot}>
        {text}
      </NavSlotAnchor>
    </GlobalNavLi>
  );
};

export default globalNavigationSlot;
